import { createApp } from 'vue';
import ShareView from '../../../health/ShareView.vue'
const appElements = document.querySelectorAll('.vue-health-share-view')

Array.from(appElements).forEach(element => {
    createApp(ShareView).mount(element);
});